import { render, staticRenderFns } from "./CouponCenter.vue?vue&type=template&id=214c751e&scoped=true&"
import script from "./CouponCenter.vue?vue&type=script&lang=js&"
export * from "./CouponCenter.vue?vue&type=script&lang=js&"
import style0 from "./CouponCenter.vue?vue&type=style&index=0&id=214c751e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c751e",
  null
  
)

export default component.exports